/* ML-02 · BULK IMPORT
   CSV import with recognised columns, duplicate and ambiguity resolution, and
   an error report that names the reason for every rejected row. */
import { Button, ListRow, Note } from '@/ui'
import { useML } from './EtabShell'

export default function ML02Import() {
  const csv = useML().csv
  return (
    <section data-frame="ML-02" style={{ display: 'grid', gap: 14 }}>
      <h2 className="t-section">Import CSV — 11 établissements</h2>
      <Note tone="ok">{csv.ready}</Note>
      <div>
        {csv.rows.map(r => (
          <ListRow key={r.title} title={r.title} meta={r.meta}
            end={<>{r.actions.map(a => (
              <Button key={a} variant="quiet" size="sm">{a}</Button>
            ))}</>} />
        ))}
      </div>
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
        <Button variant="primary" size="sm">Importer les 9 lignes prêtes</Button>
        <Button variant="quiet" size="sm">Télécharger le modèle CSV</Button>
        <Button variant="quiet" size="sm">Rapport d’erreurs (.csv)</Button>
      </div>
      <p className="t-body">
        Le modèle contient les colonnes attendues et un exemple. Le rapport d’erreurs reprend vos
        lignes avec la raison du rejet — corrigez et réimportez.
      </p>
    </section>
  )
}
